/**
 * Prova a parsare il campo `message` di una risposta backend come JSON di errori per campo.
 * Restituisce un Record<fieldName, errorMessage> se il JSON è un oggetto non-null non-array,
 * altrimenti null (fallback al banner globale).
 */
export function parseBackendValidationErrors(message: string): Record<string, string> | null {
  try {
    const parsed = JSON.parse(message)
    if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, string>
    }
  } catch {
    // not JSON
  }
  return null
}
